module.exports = "/images/certificat_de_arta_cadou.png?3f3a7b6dcbbf2b93134ad3f28d193c84";